import { useEffect } from 'react'
import { useQuery } from 'react-query'

import { fetchObjectById, FetchObjectByIdResponse } from '../../shared/api'
import { ErrorMessage } from 'infrastructure/shared/types'

export default function useObjectClassById(objectUuid: string | undefined) {
  const { data, refetch, error } = useQuery<
    FetchObjectByIdResponse,
    ErrorMessage
  >(['object-by-id', objectUuid], () => fetchObjectById(objectUuid), {
    enabled: false
  })

  useEffect(() => {
    refetch()
  }, [objectUuid, refetch])

  useEffect(() => {
    if (error) {
      console.log('error', error.message)
    }

    if (data && !data.success) {
      console.log(data.message)
    }
  }, [error, data])

  return data?.data?.object.uuid_Objectclass
}
